import { useQuery } from '@tanstack/react-query';
import type { APICommonResponse } from 'src/types/common.types';

import type { getTermsRequest, getTermsResponse } from './terms.dto';
import { termsService } from './terms.service';

const USE_TERMS_QUERY_KEY = {
  terms: 'terms',
};

// select 변환 함수 — module-scope 로 두어 함수 reference 안정화
const selectTerms = (res: APICommonResponse<getTermsResponse>) => {
  const { data } = res.data;
  return {
    count: data.count,
    rows: data.rows.map((row) => ({
      sequence: row.terms_seq,
      title: row.terms_title,
      contents: row.contents,
    })),
  };
};

// 약관 목록 조회 (terms_div 기준)
interface GetTermsParams {
  termsType: getTermsRequest['termsType'];
}

export const useTermsQuery = ({ termsType }: GetTermsParams) => {
  return useQuery({
    queryKey: [USE_TERMS_QUERY_KEY.terms, termsType],
    queryFn: () => termsService.getTerms({ termsType }),
    select: selectTerms,
    enabled: !!termsType,
  });
};

